import { render, staticRenderFns } from "./DeleteProjectDialog.vue?vue&type=template&id=355ed197&scoped=true&"
import script from "./DeleteProjectDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ed197",
  null
  
)

export default component.exports